import { useMemo } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { toggleSpecialty } from 'src/lib/sante-api/specialties'

import { FETCH_SPECIALTIES_QUERY_KEY } from './useFetchSpecialtiesQuery'

/**
 *
 * @param {import('@tanstack/react-query').UseMutationOptions} options
 */
export function useToggleSpecialtyMutation(options = {}) {
  const queryClient = useQueryClient()

  const queryKey = useMemo(() => [FETCH_SPECIALTIES_QUERY_KEY, {}], [])

  return useMutation({
    ...options,

    mutationFn: toggleSpecialty,

    onMutate: async (specialtyId) => {
      await queryClient.cancelQueries({ queryKey })

      const previous = queryClient.getQueryData(queryKey)

      const updated = previous.map((specialty) => {
        return specialty.id === specialtyId
          ? {
              ...specialty,
              is_deletable: false,
              deleted_at: specialty.deleted_at ? null : new Date().toISOString(),
            }
          : specialty
      })

      queryClient.setQueryData(queryKey, updated)

      return { previous }
    },

    onError: (err, variables, context) => {
      if (context?.previous) queryClient.setQueryData(queryKey, context.previous)

      if (options?.onError) options.onError(err, variables, context)
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey })
    },
  })
}
